module.exports = __webpack_public_path__ + "static/media/iconFive.565c34e8.svg";